import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import { Row, Col } from "antd";
import bannerImage3 from "../../assets/incubationBg.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";
import { ShareArticleButtons } from "../../components/common/share-article-buttons";

const ImprintDamechionwurah = () => {
  const title = "{BRAND.domainLabel} meets with Dame Chi Onwurah MP to discuss online safety."

  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>
            {title}
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <h3>Press Releases</h3>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on July, 2025</p>
                <h1 className={styles.postTitle}>
                  {title}
                </h1>
              </div>

              <ShareArticleButtons title />

            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p>
                On 1 July 2025, {BRAND.domainLabel} met with Dame Chi Onwurah MP, Chair
                of the Science and Technology Select Committee.
              </p>

              <p>
                In light of the Committee&apos;s recent inquiry into social
                media, misinformation and harmful algorithms, the meeting
                provided {BRAND.domainLabel} with a valuable opportunity to highlight
                the platform&apos;s industry- leading content moderation system,
                designed to protect users from misinformation and harmful
                content.
              </p>

              <p>
                This valuable meeting deepened {BRAND.domainLabel}&apos;s understanding
                of the Committee&apos;s work and advanced its engagement with
                key political stakeholders on online safety.
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default ImprintDamechionwurah;
